"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bannerForm = _interopRequireDefault(require("../components/bannerForm"));
var _colForm = _interopRequireDefault(require("../components/colForm"));
var _default = {
  components: {
    bannerForm: _bannerForm.default,
    colForm: _colForm.default
  },
  data: function data() {
    return {
      carousel: [],
      configData: [{
        backgroundImg: '',
        title: '',
        subtitle: '',
        jumpUrl: ''
      }, {
        backgroundImg: '',
        title: '',
        subtitle: '',
        jumpUrl: ''
      }]
    };
  },
  methods: {
    // 升序
    upSortItem: function upSortItem(index) {
      if (index === 0) {
        return;
      }
      var item = this.carousel[index];
      this.$set(this.carousel, index, this.carousel[index - 1]);
      this.$set(this.carousel, index - 1, item);
    },
    // 降序
    downSortItem: function downSortItem(index) {
      if (index === this.carousel.length - 1) {
        return;
      }
      var item = this.carousel[index];
      this.$set(this.carousel, index, this.carousel[index + 1]);
      this.$set(this.carousel, index + 1, item);
    },
    // 删除推荐位
    deleteItem: function deleteItem(index) {
      this.carousel.splice(index, 1);
    },
    addBanner: function addBanner() {
      this.carousel.push({
        img: '',
        jumpType: '',
        jumpUrl: '',
        goods: {}
      });
    }
  }
};
exports.default = _default;